import React, { useState, useEffect } from "react";
import Navbar from "../Navbar"; 
import Sidebar from "./superAdminSidebar"; 
import Footer from "../Footer"; 
import { handleAPIRequest } from "../../../api/api"; 
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";

const VisitorsList = () => {
  const [visitorsList, setVisitorsList] = useState([]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    const fetchVisitors = async () => {
      try {
        const response = await handleAPIRequest(
          "get",
          "get-visitors-A",
          null,
          null,
          token
        );
        setVisitorsList(response.visitors || []);
      } catch (error) {
        console.error("Error fetching visitors:", error);
        toast.error("Failed to fetch visitors.");
      }
    };

    fetchVisitors();
  }, [token]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  
  return (
    <div className="flex min-h-screen">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex-1 flex flex-col">
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="flex-grow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold text-gray-700">Visitors</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">
                    Ip Address 
                  </th>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">
                    Accessed At
                  </th>
                </tr>
              </thead>
              <tbody>
                {visitorsList.length > 0 ? (
                  visitorsList.map((visitor) => (
                    <tr key={visitor.id} className="border-b">
                      <td className="py-3 px-6 text-gray-600">{visitor.ip_address}</td>
                      <td className="py-3 px-6 text-gray-600">
    {new Date(visitor.created_at).toLocaleString("en-US", {
        weekday: "long", // Full day name
        day: "2-digit",
        month: "long", // Full month name
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // AM/PM format
    })}
</td>
                    
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="py-3 px-6 text-center text-gray-500">
                      No visitors available at the moment.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </main>
        <ToastContainer />
        <Footer />
      </div>
    </div>
  );
};

export default VisitorsList;
